/**
 * design-tools/tokens.js
 * Digital Billions Group — Icy Grey Design Token System
 * Cool steel-blue accent on a near-black dark theme.
 */

export const PALETTE = {
  // Shared steel-blue accent scale (kept as `teal*` keys so existing
  // component references — PALETTE.teal400, etc. — don't need renaming)
  teal50:  '#C9D6E3',
  teal100: '#B3C5D6',
  teal200: '#9DB4CA',
  teal300: '#88A3BC',
  teal400: '#7FA1C2', // primary accent — dark theme CTA
  teal500: '#6B8FB0',
  teal600: '#4A7191',
  teal700: '#3A5C78',
  teal800: '#2E4A60',
  teal900: '#22384A',

  // Secondary accent — used for featured pricing cards. Cool, not warm.
  gold:       '#9DB4CA',
  goldMid:    '#7FA1C2',
  goldDark:   '#3A5C78',
  goldFaint:  'rgba(127,161,194,0.12)',
  goldBorder: 'rgba(127,161,194,0.35)',

  // Dark surfaces — icy-grey dark theme
  ink:       '#0D0F14',
  inkDeep:   '#08090C',
  inkMid:    '#171A21',
  inkSoft:   '#1F232C',
  bgAlt:     '#13151B',
  bgSurface: '#171A21',
  bgCard:    '#1B1E26',
  bgElevated:'#262B36',

  // Diagram / readable ink — lighter so visible on dark bg
  diagramInk:  '#5B6072',
  diagramFaint:'#3A4051',

  border:       'rgba(58, 64, 81, 0.5)',
  borderBright: 'rgba(127, 161, 194, 0.32)',

  // Light text scale
  white:     '#F0F1F4',
  whiteMid:  'rgba(240,241,244,0.78)',
  whiteSoft: 'rgba(240,241,244,0.58)',
  whiteMuted:'rgba(240,241,244,0.38)',
  whiteFaint:'rgba(240,241,244,0.15)',

  // Glow
  glow:      '#7FA1C2',
  glowFaint: 'rgba(127,161,194,0.12)',
};

export const GLOW = {
  teal:       '0 0 20px rgba(127,161,194,0.35), 0 0 60px rgba(127,161,194,0.1)',
  tealStrong: '0 0 30px rgba(127,161,194,0.55), 0 0 80px rgba(127,161,194,0.2)',
  tealSoft:   '0 0 12px rgba(127,161,194,0.2)',
  gold:       '0 0 24px rgba(157,180,202,0.35), 0 0 60px rgba(157,180,202,0.12)',
  goldStrong: '0 0 32px rgba(157,180,202,0.5), 0 0 80px rgba(157,180,202,0.18)',
  card:       '0 4px 32px rgba(0,0,0,0.5), 0 1px 0 rgba(127,161,194,0.12)',
  cardHover:  '0 8px 48px rgba(0,0,0,0.6), 0 0 24px rgba(127,161,194,0.18)',
  text:       '0 0 22px rgba(127,161,194,0.65), 0 0 48px rgba(127,161,194,0.25)',
  goldText:   '0 0 16px rgba(157,180,202,0.5)',
};

export const SHADOW = {
  sm:  '0 2px 8px rgba(0,0,0,0.4)',
  md:  '0 4px 24px rgba(0,0,0,0.5)',
  lg:  '0 8px 48px rgba(0,0,0,0.6)',
  xl:  '0 16px 80px rgba(0,0,0,0.7)',
};

export const MOTION = {
  fast:     '0.35s',
  medium:   '0.75s',
  slow:     '1.2s',
  cinematic:'2s',
  ease:     'cubic-bezier(0.16, 1, 0.3, 1)',
  easeIn:   'cubic-bezier(0.4, 0, 1, 1)',
  easeOut:  'cubic-bezier(0, 0, 0.2, 1)',
};

export const GLASS = {
  surface: {
    background: 'rgba(23, 26, 33, 0.7)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    border: '1px solid rgba(58, 64, 81, 0.5)',
  },
};
